// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AuthWrap_wrap__2vvcM","title":"AuthWrap_title__3bWgJ"};